import React from 'react';
import getSurcharges from '../selectors/getSurcharges';
import { useAppSelector } from '../app/hooks';
import Line from './Line';

const Surcharges = () => {
  const surcharges = useAppSelector(getSurcharges);

  return (
    <div>
      {surcharges
        .filter(surcharge => surcharge.amount)
        .map(surcharge => (
          <div className="py-1" key={surcharge.description}>
            <Line label={surcharge.description} amount={Number(surcharge.amount)} deemphasised />
          </div>
        ))}
    </div>
  );
};

export default Surcharges;
